module.exports = {"address1":"Address - FR"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/AutocompleteInput/locales/fr.json
// module id = 1194
// module chunks = 0